import { Divider, Grid, Typography } from "@mui/material"
import React, { useEffect, useRef } from "react"
import { showNewOfficeSection } from "Pages/Admin/Users/@signals"
import { IconSeeker } from "@ui-seeker/core"
import OfficeNameField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeName"
import OfficeTypeField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeType"
import OfficeCodeField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeCode"
import OfficeTimeZoneField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeTZ"
import OfficeCountryField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeCountry"
import SubmitNewOffice from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/SubmitOffice"


export default function UserNewOfficeSubSection() {
	const sectionRef = useRef(null)

	useEffect(() => {
		if (showNewOfficeSection.value) {
			sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
		}
	}, [showNewOfficeSection.value])

	if (!showNewOfficeSection.value) return null

	return <>
		<Grid ref={sectionRef} container spacing={2} sx={{ ml: 5, width: "100%" }}>
			<Grid item>
				<Typography
					variant="h6"
					sx={{
						display: 'flex',
						gap: .8,
						alignItems: 'center',
						py: 1,
						pr: 2,
						borderBottom: "2px solid",
						color: "secondary.main",
						borderColor: "secondary.main"
					}}>
					<IconSeeker icon="arrow-right-to-city" iconWeight="solid" sx={{ fontSize: "1.2rem", color: "primary.main" }}/>
					New Office
				</Typography>
			</Grid>
			<Grid item xs={12}/>
			<Grid item xs={8}>
				<OfficeNameField/>
			</Grid>
			<Grid item xs={5}>
				<OfficeTypeField/>
			</Grid>
			<Grid item xs={3.5}>
				<OfficeCodeField/>
			</Grid>
			<Grid item xs={4}>
				<OfficeTimeZoneField/>
			</Grid>
			<Grid item xs={4.5}>
				<OfficeCountryField/>
			</Grid>
			<Grid item xs={4}>
				<SubmitNewOffice/>
			</Grid>
		</Grid>
		<Divider sx={{ my: 2, color: "secondary.main" }}/>
	</>
}